export default __webpack_public_path__ + "static/media/molar-tooth.aa81b4ce.svg";